import React, { Suspense } from 'react';
import { Box, Underline } from '@sparknz/spark-pattern-library';

import { ProgressBar } from 'journey/checkout/components/ProgressIndicator/components';
import Plans from 'journey/productDetails/components/Plans';
import ReviewChangePlan from 'journey/productDetails/components/ReviewChangePlan';
import { useProductDetails } from 'journey/productDetails/provider';
import { IfpEligibilityCheckSteps } from 'journey/productDetails/typings';
import { FallbackLoadingSpinner } from 'shared/components';
import { getProgressionIndicatorValues } from '../../utils/ProgressIndicator.utils';
import {
  IfpAccountSelector,
  IfpExistingPlanSelector,
} from '../AddToCartSection';
import BreadCrumbs from '../BreadCrumbs';
import IneligiblePlanResult from '../IneligiblePlanResult';

const PrimaryActionLayerContent = () => {
  const { ifpEligibility } = useProductDetails();

  const { stepProgression } = getProgressionIndicatorValues(
    ifpEligibility.activeStep,
    ifpEligibility.sections,
    5,
  );

  const showIfpAccountSelector =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.AccountSelection;
  const showIfpPlanSelector =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.PlanSelection;
  const showEligiblePlanSelector =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.LineSelection;
  const showReviewChangePlanSelector =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.ReviewPlan;
  const showIneligiblePlanResult =
    ifpEligibility.activeStep === IfpEligibilityCheckSteps.IneligiblePlan;

  const hasProgressIndicator = ifpEligibility.isCheckRequired;
  const hasUnderline = !hasProgressIndicator;

  return (
    <>
      {hasProgressIndicator ? (
        <>
          <BreadCrumbs />
          <ProgressBar value={stepProgression} />
        </>
      ) : null}

      {hasUnderline ? (
        <Box pt={['s2', 's3']}>
          <Underline />
        </Box>
      ) : null}

      <Box px={['s3', 's4', 's6']}>
        {showIfpAccountSelector ? (
          <Suspense fallback={<FallbackLoadingSpinner />}>
            <IfpAccountSelector />
          </Suspense>
        ) : null}
        {showEligiblePlanSelector ? <IfpExistingPlanSelector /> : null}
        {showIfpPlanSelector ? <Plans /> : null}
        {showReviewChangePlanSelector ? <ReviewChangePlan /> : null}
        {showIneligiblePlanResult ? <IneligiblePlanResult /> : null}
      </Box>
    </>
  );
};

export default PrimaryActionLayerContent;
